import { Injectable } from '@angular/core'
@Injectable({
  providedIn: 'root'
})
export class FuseqSessionService {
  private _session: any
  set session (value) {
    this._session = value
    if (value == null) {
      localStorage.removeItem('currentUser')
    } else {
      localStorage.setItem('currentUser', JSON.stringify(value))
    }
  }

  get session () {
    if (this._session) {
      return this._session
    }
    const raw = localStorage.getItem('currentUser')
    if (!raw) {
      return null
    }
    try {
      return JSON.parse(raw)
    } catch {
      localStorage.removeItem('currentUser')
      return null
    }
  }
}
